import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const masonryOptions = {
    itemSelector:       '.main-news__item',
    columnWidth:        '.main-news__item',
    percentPosition:    true,
    transitionDuration: '0'
}

const init = (instance, $section) => {
    instance.$el           = $section;
    instance.$masonry      = new Masonry(instance.$el, masonryOptions);
    instance.$imagesLoaded = imagesLoaded(instance.$el, () => {
        instance.$masonry.layout();
    });

    resize(instance);
    instance.fakeImg();

    window.addEventListener('resize', () => {
        resize(instance);
    })

};

const resize = (instance) => {
    if (($(window).width() > 1560 || (1025 > $(window).width() && $(window).width() > 900 && $('.content').width() > 900))) {
        $('.main-news__item').width('50%');
        instance.$masonry.layout();
    } else {
        $('.main-news__item').width('100%');
        instance.$masonry.layout();
    }
};

export default class MainNews {
    constructor($section) {
        return $section ? init(this, $section) : {};
    }

    fakeImg() {
        $('.main-news__pic-wrapper--fake').each(function () {

            var $el  = $(this),
                $img = $el.find('img');

            var src    = $img.attr('data-original');
            var pic    = new Image();
            pic.src    = src;
            pic.onload = function () {
                $el.removeClass('main-news__pic-wrapper--fake');
                $img.attr('src', src);
            }
        });
    }

}
